export interface Projeto {
  id: string;
  title: string;
  subtitle?: string;
  authors: string[];
  year: number;
  orientador: string;
  coverImage: string;
  pdfFile: string;
  description?: string;
}

export const projetos: Projeto[] = [
  {
    id: "mt-facanha",
    title: "Infinitude (in)visível",
    subtitle: "Joias-corpo produzidas com tampas plásticas", // Add subtitle here if needed
    authors: ["Melissa Teixeira Façanha"],
    year: 2025, // Update with actual year
    orientador: "Jeanine Geammal", // Update with actual orientador
    coverImage: "/Projetos/MTFacanha/capa.png",
    pdfFile: "/Projetos/MTFacanha/MTFacanha.pdf",
    description: "",
  },
  {
    id: "rl-alcantara",
    title: "Pteromorpha",
    subtitle: "Modelo didático articulado de asa de aves.", // Add subtitle here if needed
    authors: ["Ryan Alcantara"],
    year: 2023, // Update with actual year
    orientador: "Anael Alves", // Update with actual orientador
    coverImage: "/Projetos/RLAlcantara/capa.png",
    pdfFile: "/Projetos/RLAlcantara/RLAlcantara.pdf",
    description: "",
  },
  {
    id: "bn-bazoni",
    title: "Panapaná",
    subtitle: "bruxas, metamorfoses e adornos na invenção de corpos.", // Add subtitle here if needed
    authors: ["Beatriz Bazoni"],
    year: 2023, // Update with actual year
    orientador: "Jeanine Geammal", // Update with actual orientador
    coverImage: "/Projetos/BNBazoni/capa.png",
    pdfFile: "/Projetos/BNBazoni/BNBazoni.pdf",
    description: "",
  },
];
